
<template>
  <svg
    :width="size"
    :height="size" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
  >
    <g id="credit-card-02">
      <path id="Icon" d="M16.5 7.5H1.5M8.25 10.5H4.5M1.5 6.15L1.5 11.85C1.5 12.6901 1.5 13.1101 1.66349 13.431C1.8073 13.7132 2.03677 13.9427 2.31901 14.0865C2.63988 14.25 3.05992 14.25 3.9 14.25L14.1 14.25C14.9401 14.25 15.3601 14.25 15.681 14.0865C15.9632 13.9427 16.1927 13.7132 16.3365 13.431C16.5 13.1101 16.5 12.6901 16.5 11.85V6.15C16.5 5.30992 16.5 4.88988 16.3365 4.56902C16.1927 4.28677 15.9632 4.0573 15.681 3.91349C15.3601 3.75 14.9401 3.75 14.1 3.75L3.9 3.75C3.05992 3.75 2.63988 3.75 2.31901 3.91349C2.03677 4.0573 1.8073 4.28677 1.66349 4.56901C1.5 4.88988 1.5 5.30992 1.5 6.15Z" :stroke="color" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    </g>
  </svg>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  size?: string | number;
  color?: string;
}>(), {
  size: 18,
  color: 'currentColor'
});
</script>